(function(){
	'use strict';
	String.prototype.hashCode = function(){
		var hash = 0;
		if (this.length === 0) return hash;
		for (var i = 0; i < this.length; i++) {
			var code = this.charCodeAt(i);
			hash = ((hash<<5)-hash)+code;
			hash = hash & hash; // Convert to 32bit integer
		}
		return hash;
	};

	$(function(){	
		$('body').on('mousedown', '[type="submit"], [type="reset"]', function(event) {
			event.preventDefault();
		});
		$('a[disabled]').on('click', function(event) {
			event.preventDefault();
		});
	});
})();

(function(angular) {
	'use strict';
	var modules = [
			'ngSanitize', 'ngAnimate', 'ngFileUpload', 'ngAria',
			'ngTagsInput', 'ui.router', 'ui.mask', 'ngMask', 'toaster', 
			'angular-medium-editor', 'ngPatternRestrict', 
			'hhv.db', 'hhv.filters', 'hhv.directives', 'hhv.map', 'hhv.analystics', 'hhv.prerender'];

	angular.module('hhv.app.map', modules)
		.config(['$urlMatcherFactoryProvider', '$urlRouterProvider', '$stateProvider', '$locationProvider', '$logProvider', 'tagsInputConfigProvider', function($urlMatcherFactoryProvider, $urlRouterProvider, $stateProvider, $locationProvider, $logProvider, tagsInputConfigProvider) {
			tagsInputConfigProvider.setTextAutosizeThreshold(50);

			$logProvider.debugEnabled(false);
			$locationProvider.html5Mode(true).hashPrefix('!');
			$urlMatcherFactoryProvider.strictMode(false);
			$urlMatcherFactoryProvider.caseInsensitive(true);

			var statedUrl = function(urlPattern){
				return ['$match', '$state', '$location', function($match, $state, $location){
							var newUrl = urlPattern.replace(/:([^:\/]+)/g, function(match, param){
								return $match[param];
							});
							//console.log(newUrl, $match, $state, $location);
							//
							var path;
							switch($state.current.name){
								case 'sub.detail':
								case 'sub':
									path = $state.params.state;
									break;
								case 'sub.search':
									path = $state.params.state  + '/search::q'.replace(':q', $state.params.query);
									break;
								case 'sub.search.detail':
									path = $state.params.state  + '/search::q'.replace(':q', $state.params.query);
									//path = path.replace(/\/search:[^\/]*/, newUrl);
									break;
								default:
									path = '';//$state.params.state ? $state.params.state : $state.current.url;
							}
							var newPattern = new RegExp(urlPattern.replace(/:[^\/]+\//, ':.*'));
							var newPath = path.replace(newPattern, '');
							//console.log("stated:", path, newUrl, newPattern, newPath);
							return newPath + newUrl;
						}];
					};
			var checkUserThenUrl = function(redirection){
				return ['HvUser', '$match', '$state', '$stateParams', '$location', 'toaster', function(HvUser, $match, $state, $stateParams, $location, toaster){
					if(HvUser.isLogin() || HvUser.isAvailable())
						return false;
					else {
						toaster.warning({
							title: '접근불가',
							body: '로그인이 필요한 서비스 입니다.'
						})
						return redirection + $location.$$url;
					}
				}];
			};

			$urlRouterProvider
				.when(/^\/(add|edit)\/?.*/i, checkUserThenUrl('/login'))
				.when(/^\/profile\/?.*/i, checkUserThenUrl('/login'))
				.when('/search?q=', '/maps/search::q/')
				.when('/search::q/', statedUrl('/search::q/'))
				.when('/@:org', statedUrl('/@:org'))
				.when('/', '/maps/')
				.otherwise('/maps/');

			$stateProvider
				.state('terms', {
					url:'/terms',
					views: {
						'aux': {templateUrl: '/terms.html'}
					}
				})
				.state('privacy', {
					url:'/privacy',
					views: {
						'aux': {templateUrl: '/privacy.html'}
					}
				})
				.state('add', {
					class: 'add',
					url: '/add/{then:.*}',
					resolve: {
						actionName: function(){
							return '등록';
						}
					},
					views: {
						'aux': {templateUrl: '/template/view/add.html', controller: ['$scope', 'actionName', function($scope, actionName){
							$scope.actionName = actionName;
						}]}
					}
				})
				.state('edit', {
					class: 'edit',
					url: '/edit/:id',
					resolve: {
						actionName: function(){
							return '수정';
						},
						item: ['HvItem', '$stateParams', function(HvItem, $stateParams){
							return HvItem.get({id: $stateParams.id}).$promise;
						}]
					},
					views: {
						'aux': {templateUrl: '/template/view/add.html', controller: ['$scope', 'actionName', 'item', function($scope, actionName, item){
							$scope.actionName = actionName;
							$scope.item = item;
						}]}
					}
				})
				.state('profile', {
					class: 'profile',
					url: '/profile',
					resolve: {
						//user: 
					},
					views: {
						'aux': {templateUrl: '/template/view/profile.html'}
					}
				})
				.state('register', {
					class: 'register',
					url: '/register/{then:.*}',
					views: {
						'aux': {templateUrl: '/template/view/register.html'}
					}
				})
				.state('login', {
					class: 'login',
					url: '/login/{then:.*}',
					views: {
						'aux': {templateUrl: '/template/view/login.html'}
					}
				})
				.state('logout', {
					class: 'logout',
					url: '/logout/{then:.*}',
					views: {
						'aux': {templateUrl: '/template/view/logout.html'}
					}
				})
				.state('sub', {
					url: '/{state:(?:maps|list)}',
					params: {
						state: {value: 'maps'}		
					},
					templateUrl: function($stateParams){
						return '/template/view/' + $stateParams.state + '.html';
					}
				})
				.state('sub.search', {
					url: '/search::query',
					class: 'search',
					onEnter: ['HvDb', '$rootScope', '$stateParams', '$timeout', 'Analytics', function(HvDb, $rootScope, $stateParams, $timeout, Analytics){
						$rootScope.mainSearch = HvDb.search($stateParams.query).then(function resolved(data){
							for (var i = data.length - 1; i >= 0; i--) {
								var org = data[i];
								org.searched = true;
							}
							$rootScope.mainSearch.results = data;
							return data;
						});
						$timeout(function(){
							Analytics.trackPage($stateParams.state+'/search/?q='+$stateParams.query);
						});
					}],
					onExit : ['$rootScope', function($rootScope){
						if($rootScope.mainSearch.results)
							for (var i = $rootScope.mainSearch.results.length - 1; i >= 0; i--) {
								var org = $rootScope.mainSearch.results[i];
								delete org.searched;
							}
						//HvDb.unsearch();
					}]
				})
				.state('sub.detail', {
					url: '/:org?action',
					class: 'detail',
					onEnter: ['HvDb', '$stateParams', function(HvDb, $stateParams){
						HvDb.selectItem($stateParams.org);
					}],
					onExit : ['HvDb', '$stateParams', function(HvDb, $stateParams){
						HvDb.deselectItems();
					}]
				})
				.state('sub.search.detail', {
					url: '/:org?action',
					class: 'search detail',
					onEnter: ['HvDb', '$stateParams', function(HvDb, $stateParams){
						HvDb.selectItem($stateParams.org);
					}],
					onExit : ['HvDb', '$stateParams', function(HvDb, $stateParams){
						HvDb.deselectItems();
					}]
				});
		}])
		.run(['$rootScope', 'db', '$location', '$state', 'HvDb', 'HvUser', function($rootScope, db, $location, $state, HvDb, HvUser){
			$rootScope.$state = $state;
			$rootScope.$currentState = $state.$current;
			$rootScope.$location = $location;
			$rootScope.db = db;
			$rootScope.HvDb = HvDb;
			$rootScope.currentUser = HvUser;
			$rootScope.mainSearch = null;//db.getItems();
			$rootScope.selectedOrg = null;
			$rootScope.selectedOrgs = [];
			$rootScope.searchedOrgs = [];
			$rootScope.highlightedOrg = null;

			$rootScope.lists = [{title:'12월의 스타트업', description: '#여행 #문화 #플랫폼 분야의 스타트업들', options: {query: '#여행 #문화 #플랫폼 @에이'}},
					{title:'활발한 스타트업', description: '최근 활동한 스타트업들', options: {query: ''}},
					{title:'주목받는 스타트업', description: '주목 받는 스타트업들', options: {query: '#소셜 #문화 #플랫폼 $짐프'}}];

		}])
		.controller('HeaderController', ['$scope', '$state', '$filter', function HeaderController($scope, $state, $filter){
			///TODO: need this to be better configured in state declaration
			$scope.title = [];
			$scope.pageTitle = function(){
				var title = $scope.title = [];
				var defaultTitle = '홍합밸리';
				if($scope.$root.HvDb.selectedItems[0])
						title.push($scope.$root.HvDb.selectedItems[0].name + ' - 기업소개');
				else if($state.params.org) 
						title.push($state.params.org + ' - 기업소개');
				if($state.params.query) title.push($filter('queryTidy')($state.params.query) + ' - 검색결과');
				if($state.params.state) defaultTitle += ' 스타트업 ' + ($state.params.state === 'maps'?'지도':'목록');
				title.push(defaultTitle);
				return title.join(' | ');
			};
			$scope.pageDescription = function(){
				var description;
				return description;

			};
			$scope.pageKeywords = function(){
				var keywords;
				return keywords;
			};
		}])
		.controller('MainController', ['$scope', '$filter', '$state', function($scope, $filter, $state){
			$scope.highlight = function(org){
				org.highlighted = true;
				$scope.$applyAsync();
			};

			$scope.unhighlight = function(org){
				org.highlighted = false;
				$scope.$applyAsync();
			};

			$scope.submitSearch = function(){
				$state.go('sub.search',{query:$filter('queryTidy')($state.params.query, true)}, {reload: true});
				//$state.go('sub.search',{query:$state.params.query}, {reload: true});
			};
		}])
		.controller('SearchController', ['$scope', '$state', function($scope, $state){
			var tempSelected = [];
			$scope.onSearchChange = function(value){
				if(!value || value === ''){
					$scope.resetSearch();
				}
			};
			$scope.onSearchItemHover = function(item){
				item.tempSelected = true; 
				tempSelected.push(item);
			};
			$scope.onSearchItemLeave = function(item){
				delete item.tempSelected;
			};
			$scope.resetSearch = function(){
				for (var i = tempSelected.length - 1; i >= 0; i--) {
					delete tempSelected[i].tempSelected;
				}
				tempSelected = [];
				$state.go('sub');
			};
		}])
		.controller('DetailController', ['$scope', function DetailController($scope){
			$scope.org = {};
			$scope.get = function(orgName){
				$scope.org = {
					name: orgName
				};
				$scope.$applyAsync();
			};
		}])
		.controller('ItemController', ['$scope', 'Upload', 'HvItem', 'HvGeocoder', 'toaster', function ItemController($scope, Upload, HvItem, HvGeocoder, toaster){
			$scope.pattern = {
				en: /^[0-9\u0000-\u007F]*$/,
				kr: /^[0-9\u1100-\u11FF\u2150-\u218F\u3130-\u318F\uAC00-\uD7AF]*$/
			};
			$scope.item = $scope.item || new HvItem();
			$scope.save = function saveItem(){

				/// TODO: Check async
			
				//if($scope.item.founding_date) = $scope.item.founding_date = new Date($scope.item.founding_date).
				if(typeof $scope.item.tags === 'string') {
					$scope.item.tags.replace(/\s*/g, '');
					$scope.item.tags = $scope.item.tags.split(',');
				}else if (typeof $scope.item.tags === 'object') {
					var tags = $scope.item.tags;
					$scope.item.tags = [];
					for (var i = 0; i < tags.length; i++) {
						$scope.item.tags.push(tags[i].name);
					}
				}

				if($scope.item.id)
					HvItem.update($scope.item, function success(value, response){
						toaster.info({
							title: '업체수정',
							body: '업체수정이 완료되었습니다.'
						})
						$scope.then('/maps/'+value.id);
					}, function failed(httpResponse) {
						toaster.error({
							title: '수정실패',
							body: httpResponse
						})
					});
				else
					HvItem.save($scope.item, function success(value, response){
						toaster.info({
							title: '업체등록 대기',
							body: '관리자 승인 후 등록 됩니다. (1~2주 소요)'
						})
						$scope.then('/maps/'+value.id);
					}, function failed(httpResponse) {
						toaster.error({
							title: '등록실패',
							body: httpResponse
						})
					});
			};

			//logoFile update
			$scope.$watch('logoFile', function (newValue) {
				if(newValue) $scope.upload([newValue]);
			});

			$scope.addressComplete = function(data){
				$scope.item.address = data.address;
				$scope.item.address_base = data.address;
				$scope.item.address_detail = data.buildingName;
				$scope.item.zipcode = data.zonecode;
				HvGeocoder.addr2coord(data.address).then(function(value){
					$scope.item.latitude = value.lat;
					$scope.item.longitude = value.lng;
				});
			};

			$scope.upload = function (files) {
				var progressHandler = function(evt) {
						var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
						console.log('progress: ' + progressPercentage + '% ' + evt.config.data.upfile.name);
					};
				var successHandler = function(data, status, headers, config) {
						console.log(data, status, headers, config);
						$scope.item.logo = '/images/'+data.filename[0];
					};
				if (files && files.length) {
					for (var i = 0; i < files.length; i++) {
						var file = files[i];
						if (!file.$error) {
							Upload.upload({
								url: 'http://map.api.hhv.or.kr:3000/files',
								data: {
									upfile: file
								}
							})
							.progress(progressHandler)
							.success(successHandler);
						}
					}
				}
			};

		}])
		.controller('AuxController', ['$scope', '$state', '$location', '$window', function($scope, $state, $location, $window){
			$scope.then = function(path){
				//refresh
				if($state.params.then)
					path = $state.params.then;
				else if(path === true)
					path = $location.path();

				if(path)
					$location.path(path);
				else if($window.history.length)
					$window.history.back();
				else 
					$location.path('/');
				return path;
			};
		}])
		.controller('ListController', ['$scope', 'HvList', function ListController($scope, HvList){
			$scope.lists = HvList.list(function success(data, headersGetter){
				angular.extend($scope.lists, data);
			});
		}])
		.controller('UserController', ['$scope', 'HvUser', 'HvPerson', function UserController($scope, HvUser, HvPerson){
			//TODO: need lazy loading for profile 
			if(HvUser.isLogin())
				$scope.user = HvPerson.get(HvUser.person);
			else if (HvUser.isAvailable()){
				$scope.user = HvPerson.get({id: HvUser.id});
			}
			else 
				$scope.user = new HvPerson();

			$scope.register = function(){
				$scope.user.name = $scope.user.name_family + $scope.user.name_given;
				$scope.response = HvUser.register(
					$scope.user, 
					function(value, getResponseHeaders){ //success
						console.log($scope.user);
						console.log(value, getResponseHeaders());
						$scope.login($scope.user);
					});
			};
			$scope.update = function(user){
				if(!user) user = $scope.user || angular.copy(HvUser.person);
				//first check login again
				$scope.response = HvUser.login(
					user,
					function success(value, getResponseHeaders){ //login success
						//put new passwd if available
						var editedUser = angular.copy(user);
						editedUser.passwd = '';
						if(user.newPasswd && user.newPasswd !== '' && user.newPasswd == user.newPasswdCheck)
							editedUser.passwd = user.newPasswd; 
						//finally update
						$scope.response = HvUser.update(
							editedUser, 
							function success(value, getResponseHeaders){ //update success
								user.$get();
								$scope.then();
							});
					},
					function failed(httpResponse){
						$scope.response.msg = httpResponse.data;
					});
			};

			$scope.findPassword = function(){
				$scope.response = HvUser.findPassword(
					$scope.user.email,
					function success(value, getResponseHeaders){
						console.log(value, getResponseHeaders());
					});
			};
			$scope.login = function(user){
				$scope.response = HvUser.login(
					$scope.user,
					function success(value, getResponseHeaders){ //success
						$scope.then();
					});
			};
			$scope.logout = function(){
				HvUser.logout(function(){
					$scope.then();
				});
			};
		}]);
})(angular);